export const INTERNATIONAL = 'INTERNATIONAL';
export const DOMESTIC = 'DOMESTIC';
export const NOT_UPLOAD_WARNING = '*Please upload the filled request template!';
export const DEFUALT_FETCH_LIST_REQUEST = {
    caseType: DOMESTIC,
    pageNumber: 0,
    pageSize: 10,
    sortField: 'createdAt',
    sortDirection: 'desc'
  };